export const getBuild = state => state.build;
